import React, { useState } from 'react';
import { Box, Button, useTheme } from '@mui/material';
import FantasyIconSelector from '@/components/shared/icons/FantasyIconSelector';

const EstadisticasEnVivoTabs = ({ tabs, onTabChange }) => {
    const [selectedTab, setSelectedTab] = useState(0);
    const theme = useTheme();

    // Ocultar tabs si solo hay una
    if (!tabs || tabs.length <= 1) {
        return null;
    }

    const handleClick = (index, tab) => {
        setSelectedTab(index);
        if (tab && tab.id) {
            const element = document.getElementById(tab.id);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
        if (onTabChange) {
            onTabChange(index);
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 1,
                marginBottom: 3,
                padding: 1,
                backgroundColor: 'background.paper',
                borderRadius: 2,
                border: `1px solid ${theme.palette.border?.main || theme.palette.divider}`,
            }}
        >
            {tabs.map((tab, index) => (
                <Button
                    key={tab.id || index}
                    onClick={() => handleClick(index, tab)}
                    variant={selectedTab === index ? 'contained' : 'outlined'}
                    size="small"
                    sx={{
                        fontSize: '14px',
                        textTransform: 'none',
                        padding: '8px 16px',
                        minWidth: 'auto',
                        borderRadius: 2,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.75,
                        border: `1px solid ${theme.palette.border?.main || theme.palette.divider}`,
                        '&:hover': {
                            backgroundColor: selectedTab === index ? undefined : 'action.hover',
                            borderColor: theme.palette.primary.main,
                        },
                    }}
                >
                    {tab.mode && <FantasyIconSelector fantasy={tab.mode} size={16} />}
                    <span>{tab.label}</span>
                </Button>
            ))}
        </Box>
    );
};

export default EstadisticasEnVivoTabs;
